const { summarizeBlockContent } = require('@ublend-npm/aula-editor-utils');

const extractAulaEditorText = ({ context, value: blocks }) =>
  blocks
    .map((block) => summarizeBlockContent(context)(block).flat().join(''))
    .filter((block) => !!block)
    .join(' ');

module.exports = extractAulaEditorText;
